<template>
  <div
    class="bet-item"
    @click="goToDetail()"
  >
    <div class="row title">
      <span class="row-desc">
        <SportIcon
          ref="SportIconSVG"
          :sport-id="data.event.sportId"
        />
        <span>{{ data.outcome.description }}</span>
        <span
          v-if="data.outcome.description === 'Bet Builder' && !isShare"
          :class="['bet-builder-arrow',{'bet-builder-arrow-active':showCustomBetMarket}]"
          @click.stop="showMarkets"
        >
          <InlineSvg
            icon="~public/images/inline/arrowleft.svg"
            width="12px"
          />
        </span>
        <img
          v-if="data.event.tournamentLogo"
          :src="data.event.tournamentLogo"
          class="logo"
        >
      </span>
      <span class="odds">{{ data.outcome.odds }}</span>
    </div>

    <div :class="['row', 'market', {'bet-builder-market': data.outcome.description === 'Bet Builder'}]">
      <span>{{ data.market.description }}</span>
    </div>

    <div v-if="data.outcome.description === 'Bet Builder' && showCustomBetMarket">
      <CustomBetMarket
        is-simple
        :list="data.subSelections"
      />
    </div>

    <div class="team-info">
      <div class="vs">
        vs
      </div>
      <div class="team-wrap">
        <div class="row team">
          <span class="name">{{ data.event.homeTeam }}</span>
        </div>

        <div class="row team">
          <span class="name">{{ data.event.awayTeam }}</span>
          <!-- match label -->
          <IconMatchLabels
            class="img-match-label tw-h-[12px]"
            :options="{
              configKey: 'commonLabeUrl',
              displayIn: '6',
              sportId: data.event.sportId,
              tournamentId: data.event.tournamentId,
              eventStatus: data.event.status
            }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { svg2canvas } from '@ms/utils/svg2canvas.js'
import SportIcon from 'wap/components/SportIcon'
import IconMatchLabels from '@ms/components/IconMatchLabels.vue'
import CustomBetMarket from '@ms/components/CustomBetMarket'
import { getMatchDetailLink } from '@ms/routes/match'

export default {
  name: 'BookingCodeItem',
  components: {
    SportIcon,
    CustomBetMarket,
    IconMatchLabels
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    isShare: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showCustomBetMarket: false
    }
  },
  created() {
    if (this.isShare) {
      this.$nextTick(() => {
        this.sportIcon2canvas()
      })
      this.showCustomBetMarket = true
    } else {
      const { subSelections } = this.data
      this.showCustomBetMarket = !(subSelections && subSelections.length > 3)
    }
  },
  methods: {
    sportIcon2canvas() {
      svg2canvas(this.$refs.SportIconSVG.$el)
    },
    showMarkets() {
      this.showCustomBetMarket = !this.showCustomBetMarket
    },
    goToDetail() {
      let link = getMatchDetailLink(this.data.event, 'href')
      if (this.data.outcome.description === 'Bet Builder') {
        link = `${link}?group=Bet Builder`
      }
      window.mstrace('CodeDetails_SelectionClick')
      location.href = link
    }
  }
}
</script>
<style lang="less" scoped>
.m-bookingCode-warp {
  & .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .row-desc {
    display: flex;
    align-items: center;

    ::v-deep svg,
    ::v-deep canvas {
      top: 0;
      margin-right: 4px;
    }

    .bet-builder-arrow {
      display: flex;
      width: 20px;
      height: 20px;
      align-items: center;
      justify-content: center;
      margin: 0;
      transform: rotate(-90deg);
      transition: all 0.2s ease-in-out;

      .inline-svg {
        font-size: 12px;

        ::v-deep svg {
          margin: 0;
        }
      }

      &-active {
        transform: rotate(90deg);
      }
    }
  }

  & .bet-item {
    padding: 8px 12px;
    border-radius: 7px;
    margin-bottom: 8px;
    background: #fff;
    color: #000;
    line-height: 16px;

    & .title {
      color: #000;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;

      .svg-icon {
        position: relative;
      }
    }

    .odds {
      color: #2f3033;
    }

    .logo {
      // width: 16px;
      height: 16px;
      margin-left: 16px;
    }

    & .market {
      font-size: 12px;

      &.bet-builder-market {
        padding-left: 20px;
        color: #666;
      }
    }

    .team-info {
      display: flex;
      align-items: center;
      margin-top: 4px;

      .vs {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        margin-right: 4px;
        background: #ececec;
        color: #999;
        font-size: 8px;
        font-style: italic;
        line-height: 12px;
        text-align: center;
      }

      .team-wrap {
        width: 80%;
        flex: 1;
      }

      .img-match-label {
        margin-top: -4px;
      }
    }

    & .name {
      max-width: 160/226 * 100%;
      color: #666;
      font-size: 12px;
      line-height: 16px;
      .ellipsis();
    }
  }
}

</style>
